// extracted by mini-css-extract-plugin
export default {"secondName":"useLanguageOptions_secondName__tXUmo"};